import React, {Component} from 'react';
import PropTypes from 'prop-types';

import StoreS3 from './../manifest/util/StoreS3.jsx';
import VideoSetPage from './VideoSetPage.jsx';
import WebPage from './../common/WebPage.jsx';
import ReferenceData from './../common/reference/ReferenceData.jsx';
import ReferenceController from './../common/reference/ReferenceController.jsx';
import Utils from './../common/Utils.jsx';
import FeedbackProjectionExtra from "./extras/FeedbackProjectionExtra";

import webroot from './../data/webroot.json';

const LOGO_FADE_IN = 1618 / 2;
const SECTION_FADE_OUT = 618 / 2;

export class HomePage extends Component {

    static propTypes = {
        section: PropTypes.string.isRequired
    }

    state = {
        ready_to_go: false,
        sections: [],
        explainers: [],
        page_content: <div/>,
        references: {},
        reference_index: null,
        section: this.props.section,
        reference_controller: null,
        content_ref: React.createRef(),
        logo_ref: React.createRef(),
    };

    element = null;

    componentDidMount() {
        const references = ReferenceData.compile()
        this.load_manifest(references);
    }

    on_reference_click(reference_index) {
        const {section, references} = this.state;
        const reference_controller = <ReferenceController
            reference_data={references[reference_index]}
            reference_title={reference_index}
            on_close_reference={() => this.compose_page(null,section)}
        />
        this.compose_page(reference_controller,section);
    }

    compose_page = (reference_controller, section) => {
        const {sections, explainers, narrative, references, extra} = this.state;
        const page_content = this.page_content(section, sections, explainers, narrative, references, extra, reference_controller)
        this.setState({
            page_content: page_content,
            reference_controller: reference_controller,
        });
    }

    page_content(section, sections, explainers, narrative, references, extra, reference_controller = null) {
        const {content_ref} = this.state;
        const video_set_page = <VideoSetPage
            key={section}
            ref={x => this.element = x}
            extra={extra}
            sections={sections}
            explainers={explainers}
            references={references}
            narrative={narrative}
            featured_section={section}
            on_reference_click={reference => this.on_reference_click(reference)}
        />
        return <div ref={content_ref}>
            {video_set_page}
            {reference_controller}
        </div>
    }

    async load_manifest(references) {
        const {section} = this.props;
        let manifest_json = {};
        try {
            manifest_json = await StoreS3.get_json_file('manifest.json');
            console.log("loaded manifest from S3", manifest_json);
        } catch (err) {
            manifest_json = webroot;
            console.log("loaded manifest from local file");
        }
        const header = manifest_json["website"]["basic video set"].items["header"].items;
        const body = manifest_json["website"]["basic video set"].items["body"].items
        const sections = body["sections"].items;
        const explainers = body["sidebars"].items;
        const narrative = body["narrative"].items;
        const extra_key = Utils.random_id();
        const extra = <FeedbackProjectionExtra
            key={extra_key}
            sections={sections}
            explainers={explainers}
            references={references}
            on_reference_click={reference => this.on_reference_click(reference)}
        />
        const page_content = this.page_content(section, sections, explainers, narrative, references, extra);
        this.setState({
            ready_to_go: true,
            sections: sections,
            explainers: explainers,
            narrative: narrative,
            header: header,
            page_content: page_content,
            references: references,
            extra: extra
        });
    }

    menu_select = section => {
        const {sections, content_ref, logo_ref} = this.state;
        Utils.animate(content_ref, SECTION_FADE_OUT, 1, 0, (value, is_last) => {
            content_ref.current.style.opacity = value;
            logo_ref.current.style.opacity = value;
            if (is_last) {
                const section_name = sections[section].slug;
                window.history.pushState(section_name, section_name, '/' + section_name);
                this.compose_page(null, section);
                this.setState({section: section});
                setTimeout(() => {
                    Utils.animate(content_ref, LOGO_FADE_IN, 0, 1, (value, is_last) => {
                        content_ref.current.style.opacity = value;
                        logo_ref.current.style.opacity = value;
                    });
                }, 100);
            }
        });
    }

    render() {
        if (!this.state.ready_to_go) {
            return '...';
        }

        const {header, sections, page_content, logo_ref, section} = this.state;
        let options = [];
        for (var key in sections) {
            if (0 === key.search('studio works:')) {
                options.push({title: sections[key].index, section: key, selectable: key !== section})
            }
        }
        return <WebPage
            brand={"mike hall studio"}
            title={header.title.value}
            blurb={header.blurb.value}
            content={page_content}
            on_menu_select={section => this.menu_select(section)}
            menu={options}
            logo_ref={logo_ref}
        />
    }
}

export default HomePage;
